import React, { Component } from 'react'
// import { connect } from 'react-redux'
import Slider from 'react-slick'
import moment from 'moment'

import { translation } from '../../../utils/helpers'

import './scrollingCalendar.scss'

const VISIBLE_DAYS = 31
const PADDING_DAYS = 45

class ScrollingCalendar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      visibleDays: []
    }
    this.prevResizeWidth = 0
    this.beforeChangeInitialized = false
    this.lastNavigatedDate = null
    this.isDragging = false
    this.itemWidth = 32
    this.sliderRef = null
    this.sliderContainerRef = null
    this.startDate = null
    this.endDate = null
    this.padStart = null
    this.padEnd = null
    this.updateVisibleDays = this.updateVisibleDays.bind(this)
    this.sliderSettings = {
      infinite: false,
      variableWidth: true,
      slidesToShow: 1, // VISIBLE_DAYS,   // does nothing with variablewidth
      // slidesToShow: 4.42857142855,    // Weeks in 31 days
      touchThreshold: 100,
      arrows: false,
      dots: false,
      swipeToSlide: true,
      swipe: true,
      speed: 200,   // Lower is faster
      beforeChange: (index) => {
        // console.log('beforeChange', index)
        if (this.beforeChangeInitialized) {   // For some reason this is called right after mounting, without an afterChange following, which locks up clicking.
          this.isDragging = true
        }
        this.beforeChangeInitialized = true
      },
      afterChange: (index) => {
        // console.log('afterChange', index)
        this.isDragging = false
        this.updateVisibleDays(this.state.visibleDays[index])
        // console.log('auth', this.props.auth)
      }
    }
    this.handleResize = this.handleResize.bind(this)
    this.updateItemWidth = this.updateItemWidth.bind(this)
  }

  updateItemWidth () {
    if (this.sliderContainerRef) {
      this.itemWidth = this.sliderContainerRef.clientWidth / VISIBLE_DAYS
      return
    }
    this.itemWidth = 0
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize)
    this.updateVisibleDays(this.props.showFromDate)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  shouldComponentUpdate (nextProps) {
    return true
    // console.log('thisProps', this.props.showFromDate.toISOString(), 'nextProps', nextProps.showFromDate.toISOString())   // Why is this always the same??
    // if (!nextProps.showFromDate || !this.props.showFromDate) return true
    // if (nextProps.showFromDate.toISOString() !== this.props.showFromDate.toISOString()) return true
    // return false
  }

  componentDidUpdate () {
    // console.log('Scrolling calendar did update', this.props)
    this.updateItemWidth()
    this.updateVisibleDays(this.props.showFromDate)
  }

  handleResize (args) {
    if (args.currentTarget.innerWidth && args.currentTarget.innerWidth !== this.prevResizeWidth) {
      this.updateItemWidth()
      this.prevResizeWidth = args.currentTarget.innerWidth
    }
  }

  updateVisibleDays (mom) {
    if (!mom) mom = moment()
    mom.startOf('day')  // Set to start of day to remove hours, minutes etc..

    if (mom.isSame(this.startDate, 'day')) return
    let prevStartDate = moment(this.startDate)
    let prevEndDate = moment(this.endDate)
    this.startDate = mom
    this.endDate = moment(mom).add(VISIBLE_DAYS - 1, 'days')  // - The 31th. day
    let start = moment(mom).subtract(Math.ceil(VISIBLE_DAYS), 'days')
    let end = moment(mom).add(Math.ceil(VISIBLE_DAYS * 2), 'days')
    let recreateDays = true

    // In order to minimize the number of times we recreate the scrollable range of days, we add a good amount of "padding" dates.
    // We only recreate the days, if the start or end ends up outside of these.
    if (!this.padStart || !this.padEnd) {
      this.padStart = moment(start).subtract(PADDING_DAYS, 'days')
      this.padEnd = moment(end).add(PADDING_DAYS, 'days')
    }

    if (this.props.onRangeUpdated) {
      this.props.onRangeUpdated(this.startDate, this.endDate)
    }

    // Don't do anything if our start and end is within pad start/end
    if (this.state.visibleDays.length > 0 && start.isAfter(this.padStart) && end.isBefore(this.padEnd)) {
      if (this.startDate.month() !== prevStartDate.month() || this.endDate.month() !== prevEndDate.month()) {
        this.forceUpdate() // trigger re-render to allow displayed months to update.
      }
      recreateDays = false
    }

    let days = this.state.visibleDays || []

    if (recreateDays) {
      this.padStart = moment(start).subtract(PADDING_DAYS, 'days')
      this.padEnd = moment(end).add(PADDING_DAYS, 'days')

      let totalDays = moment.duration(this.padEnd.diff(this.padStart)).as('days')

      // Clear existing days, and recreate from new range
      days.length = 0
      for (let d = 0; d < totalDays; d++) {
        days.push(moment(this.padStart).add(d, 'days'))
      }
    }

    let index = days.findIndex(x => x.isSame(mom, 'day'))
    if (recreateDays) {
      this.setState({visibleDays: days}, () => {
        // Look in array for index of day that matches the one we want to scroll to.
        if (index === -1) {
          index = 0
        }
        setTimeout(() => {
          // this.currentDayIndex = index
          this.sliderRef.slickGoTo(index, true)
        })
      })
    } else {
      // If startDate was changed, make sure the slider is scrolled to that day.
      if (!prevStartDate.isSame(this.startDate, 'day')) {
        let index = days.findIndex(x => x.isSame(mom, 'day'))
        if (index !== -1) {
          this.sliderRef.slickGoTo(index)
        }
      }
    }
    this.isDragging = false
  }

  render () {
    return (
      <div className='element-scrollingcalendar'>
        {this.renderControls()}
        {this.renderCalendar()}
      </div>
    )
  }

  renderCalendar () {
    const renderScrollableDay = (mom, index) => {
      let isStartOfWeek = mom.day() === 1   // Monday
      let isEndOfWeek = mom.day() === 0     // Sunday
      let isMiddleOfWeek = mom.day() === 4  // Thursday
      let weekText = translation(250) + ' ' + mom.format('W')
      let dayOfMonthText = mom.date()
      let isToday = mom.isSame(moment(), 'day')
      const onClick = () => {
        // console.log('onClick', 'isdragging', this.isDragging)
        if (this.isDragging) return
        if (this.props.onItemClick) this.props.onItemClick(mom)
      }
      return (
        <div key={'item_' + index} className='element-scrollingcalendar__item' style={{width: this.itemWidth}} onClick={onClick}>
          {isStartOfWeek && <div className='week week__start'>&nbsp;</div>}
          {isMiddleOfWeek && <div className='week'>{weekText}</div>}
          {isEndOfWeek && <div className='week week__end' >&nbsp;</div>}
          {!isStartOfWeek && !isMiddleOfWeek && !isEndOfWeek && <div>&nbsp;</div>}
          <div className={isToday ? 'day current' : 'day'}>{dayOfMonthText}</div>
        </div>
      )
    }

    return (
      <div className='element-scrollingcalendar__container' ref={sliderContainer => { this.sliderContainerRef = sliderContainer }}>
        <Slider {...this.sliderSettings} ref={slider => { this.sliderRef = slider }}>
          {this.state.visibleDays.map((x, i) => renderScrollableDay(x, i))}
        </Slider>
      </div>
    )
  }

  renderControls () {
    if (!this.props.showControls) return null
    if (!this.startDate || !this.endDate) return
    let firstMonth = this.startDate.month()
    let lastMonth = this.endDate.month()

    // Determine the month(s) we need to display.
    let shownMonths = []
    for (let m = firstMonth; m !== lastMonth; m = (m + 1) % 12) { // Handle end of year wrap around. ("++m % 12" currently crashes Chrome???)
      shownMonths.push(m)
    }
    if (!shownMonths.includes(lastMonth)) {
      shownMonths.push(lastMonth)
    }

    // We potentially have to display up to 3 months, in which case we shorten the names.
    let formattedMonths = shownMonths.length < 3 ? shownMonths.map(m => moment().month(m).format('MMMM')) : shownMonths.map(m => moment().month(m).format('MMM'))
    let monthsText = formattedMonths.join(' / ')

    let now = moment()
    let showGotoNow = now.isBefore(this.startDate, 'day') || now.isAfter(this.endDate, 'day')

    return (
      <div className='element-scrollingcalendar__controls'>
        {showGotoNow && <div className='go-to-now' onClick={() => { this.updateVisibleDays(moment().startOf('week')) }}>{translation(18281)}</div> || <div>&nbsp;</div>}
        <div className='months'>{monthsText}</div>
      </div>
    )
  }
}

ScrollingCalendar.defaultProps = {
  showControls: true,
  showFromDate: moment(),
  onRangeUpdated: (from, to) => { console.log('Range updated', from.format('YYYY-MM-DD'), ' - ', to.format('YYYY-MM-DD')) }, // Callback to retrieve the displayed range as two moments when the calendar is scrolled.
  onItemClick: (mom) => { console.log('Clicked', mom.format('YYYY-MM-DD')) }
}

// function mapStateToProps (state) {
//   return {
//     auth: state.auth
//   }
// }
// export default connect(mapStateToProps, { })(ScrollingCalendar)

export default ScrollingCalendar



// WEBPACK FOOTER //
// ./src/app/shared/elements/scrollingCalendar/index.js